<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box ">
    <ul class="breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
          <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
            (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
        </li>
      </ul>
    </ul>
    <div class="top-box-content">
      <!-- <h1 class="main-title">Order Processing</h1> -->
      <h1 class="main-title">Waste Entry Validation & Supervisory Screen </h1>
    </div>
  </div>
  <form [formGroup]="wasteFilterForm">
    <div class="wrapper-box wrapper-box-shadow table-wrapper">
      <!-- <div class="content-top-box-content">
      <h1 class="content-title">Process Order</h1>
    </div> -->
      <div class="content-top-row content-top-row-order-processing">
        <!-- GROUP -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <!-- <mat-label> Group </mat-label> -->
          <mat-label class="placeholder-title">{{langObj ? langObj?.Group : ('Group' | translate)}}
          </mat-label>
          <mat-select formControlName="group" (selectionChange)="getPlants($event)" panelClass="testClass"
            name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'TypeName'" [array]="groupList"
              (filteredReturn)="filteredGroups = $event"></mat-select-filter>
            <mat-option *ngFor="let group of filteredGroups" [value]="group.TypeId">
              {{group.TypeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-label class="placeholder-title">{{langObj ? langObj?.Plant : ('Plant' | translate)}}
          </mat-label>
          <!-- <mat-label> Plant </mat-label> -->
          <mat-select formControlName="plant" (selectionChange)="getUnits($event)" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'DeptDesc'" [array]="plantList"
              (filteredReturn)="filteredPlant = $event"></mat-select-filter>
            <mat-option *ngFor="let plant of filteredPlant" [value]="plant.DeptId">
              {{plant.DeptDesc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-date-range-input [rangePicker]="pickerForScorecard">
            <input matStartDate formControlName="dateStart" placeholder="From Date" [readOnly]="true" />
            <input matEndDate formControlName="dateEnd" placeholder="To Date" [readOnly]="true"
              (dateChange)="onChangeDate($event)" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="pickerForScorecard">
          </mat-datepicker-toggle>
          <mat-date-range-picker #pickerForScorecard>
          </mat-date-range-picker>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-label class="placeholder-title">{{langObj ? langObj?.Unit : ('Unit' | translate)}}
          </mat-label>
          <!-- <mat-label> Unit </mat-label> -->
          <mat-select formControlName="unit" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'PU_Desc'" [array]="unitList"
              (filteredReturn)="filteredUnit = $event"></mat-select-filter>
            <mat-option [value]="'0'">
              All
            </mat-option>
            <mat-option *ngFor="let unitObj of filteredUnit" [value]="unitObj.PU_Id">
              {{unitObj.PU_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-label class="placeholder-title">{{langObj ? langObj?.ProcessOrder : ('ProcessOrder' | translate)}}
          </mat-label>
          <!-- <mat-label> ProcessOrder </mat-label> -->
          <mat-select formControlName="processOrder" panelClass="testClass" name="Status">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'ProcessOrder'" [array]="poList"
              (filteredReturn)="filteredPo = $event"></mat-select-filter>
            <mat-option [value]="'0'">
              All
            </mat-option>
            <mat-option *ngFor="let poObject of filteredPo" [value]="poObject.PP_Id">
              {{poObject.ProcessOrder}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-mini-fab mat-button color="primary" type="button" pTooltip="Search" tooltipPosition="top" style="margin-left: 10px;margin-top: auto;
            margin-bottom: auto;" (click)="getWasteData()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
      <mat-card-content>

        <!-- <div>
          <button (click)="onBtExport()" style="margin-bottom: 5px; font-weight: bold;">
            Export to Excel
          </button>
        </div>
        <div class="grid-wrapper">
          <ag-grid-angular style="width: 100%; height: 20vw;" class="ag-theme-alpine"
            [defaultCsvExportParams]="defaultCsvExportParamsnew"
            [defaultExcelExportParams]="defaultExcelExportParamsnew" [columnDefs]="columnDefsnew"
            [defaultColDef]="defaultColDefnew" [masterDetail]="true"
            [detailCellRendererParams]="detailCellRendererParamsnew" [excelStyles]="excelStyles" [rowData]="rowDatanew"
            (gridReady)="onGridReadynew($event)"></ag-grid-angular>
        </div> -->


        <!-- <div style="display: flex; justify-content: flex-end;">
          <button type="button" class="btn btn-success" pTooltip="Export Only Headers" tooltipPosition="top"><i
              class="fa fa-file-excel-o" aria-hidden="true"></i></button>
          <button type="button" class="btn btn-success" pTooltip="Export All Data" tooltipPosition="top"
            style="margin-left: 20px;"><i class="fa fa-file" aria-hidden="true"></i></button>
        </div> -->
        <div class="exportBtn">
          <div style="margin-right: 5px;">
            <button mat-flat-button color="accent" type="button" (click)="exportExcelData('Parent')">
              {{langObj ? langObj?.ExportParent : ('ExportParent' | translate)}}
              </button>
          </div>
          <div style="margin-right: 5px;">
            <button mat-flat-button color="accent" type="button" class="w-22" (click)="onBtnExportWaste()">
              {{langObj ? langObj?.ExportParentwithchild : ('ExportParentwithchild' | translate)}}
            </button>
          </div>
          <div>
            <button mat-flat-button color="accent" type="button" class="w-22" (click)="exportExcelData('ParentDetail')">
              {{langObj ? langObj?.Export : ('Export' | translate)}}
            </button>
          </div>
        </div>
        <ag-grid-angular style="width: 100%;" #eGrid1 class="ag-theme-alpine" [rowData]="rowData"
          [columnDefs]="columnDefs" (gridReady)="onGridReady1($event)" (cellClicked)="cellClicked($event)" [gridOptions]="gridOptions"
          [detailCellRendererParams]="detailCellRendererParams" [masterDetail]="true" [isRowMaster]="isRowMaster" [excelStyles]="excelStyles" [defaultExcelExportParams]="defaultExcelExportParams"
          [pagination]="true" [paginationPageSize]="10" [loadingOverlayComponent]="loadingOverlayComponent">
        </ag-grid-angular>
      </mat-card-content>
    </div>
  </form>
</div>
<ng-template #addWasteModal>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>{{langObj ? langObj?.AddWaste : ('Add Waste' | translate)}}
      </h2>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <mat-dialog-content style="overflow:unset">
    <form [formGroup]="AddWasteEnteryForm">
      <div class="content-top-row content-top-row-order-processing">

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px;width: 30%; background-color: #f0f0f0f5;">
          <!-- <mat-label>PO</mat-label> -->
          <mat-label class="placeholder-title">{{langObj ? langObj?.PO : ('PO' | translate)}}
          </mat-label>
          <input formControlName="po" matInput name="po" readonly />
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px;width: 30%;background-color: #f0f0f0f5;">
          <!-- <mat-label>Item</mat-label> -->
          <mat-label class="placeholder-title">{{langObj ? langObj?.Item : ('Item' | translate)}}
          </mat-label>
          <input formControlName="item" matInput name="item" readonly />
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px;width: 30%;background-color: #f0f0f0f5;">
          <!-- <mat-label>Operation Name</mat-label> -->
          <mat-label class="placeholder-title">{{langObj ? langObj?.OperationName : ('OperationName' | translate)}}
          </mat-label>
          <input formControlName="operation" matInput name="operation" readonly />
        </mat-form-field>

      </div>
      <div class="content-top-row content-top-row-order-processing">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px;width: 30%;background-color: #f0f0f0f5;">
          <!-- <mat-label>Machine</mat-label> -->
          <mat-label class="placeholder-title">{{langObj ? langObj?.Machine : ('Machine' | translate)}}
          </mat-label>
          <input formControlName="machine" matInput name="machine" readonly />
        </mat-form-field>
        <!-- <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="background-color: #f0f0f0f5;width: 30%;margin-left: 10px;">
          <mat-date-range-input [rangePicker]="pickerForScorecard">
            <input matStartDate formControlName="dateStart" placeholder="From Date" readonly />
            <input matEndDate formControlName="dateEnd" placeholder="To Date" readonly />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="pickerForScorecard">
          </mat-datepicker-toggle>
          <mat-date-range-picker #pickerForScorecard>
          </mat-date-range-picker>
        </mat-form-field> -->
        <div class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="background-color: #f0f0f0f5;width: 30%;margin-left: 10px;">
          <!-- <label class="floating-label">{{
              langObj ? langObj?.DateRange : ("DateRange" | translate)
            }}</label> -->
          <label class="floating-label">Date Range</label>
          <input type="text" matInput ngxDaterangepickerMd formControlName="datePicker" [timePicker]="true"
            [timePicker24Hour]="true" [showDropdowns]="true" readonly [closeOnAutoApply]="true"
            [locale]="{ format: 'DD/MM/YYYY HH:mm' }" [autoApply]="true" [disabled]="true" />
        </div>
      </div>
      <div class="content-top-row content-top-row-order-processing">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 1px;;width: 30%;">
          <mat-label>{{
            langObj ? langObj?.CategoryType : ("CategoryType" | translate)
            }}</mat-label>
          <mat-label>
            CatagoryType
          </mat-label>
          <mat-select formControlName="categoryType" panelClass="testClass" name="cattype">
            <mat-option *ngFor="let fault of faultList" [value]="fault.FaultId">
              {{ fault.FaultName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px;width: 30%;">
          <mat-label>{{wasteLabel}}</mat-label>
          <input type="number" min="0" formControlName="amount" matInput name="amount" />
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px;width: 30%;">
          <mat-label class="placeholder-title">{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}
          </mat-label>
          <input formControlName="remarks" matInput name="remarks" />
        </mat-form-field>
      </div>
      <div class="content-top-row content-top-row-order-processing" style="justify-content: end;">
        <button mat-mini-fab mat-button [disabled]="!AddWasteEnteryForm.valid" color="primary" type="button"
          pTooltip="Save" tooltipPosition="top" style="margin-left: 10px;margin-top: auto; margin-bottom: auto;"
          (click)="addWasteEntry()" *ngIf="!editMode">
          <i class="fa fa-save" style="color: #fff"></i>
        </button>
        <button [disabled]="!AddWasteEnteryForm.valid" mat-mini-fab mat-button color="primary" type="button"
          pTooltip="Edit" tooltipPosition="top" style="margin-left: 10px;margin-top: auto; margin-bottom: auto;"
          (click)="editWasteEntry()" *ngIf="editMode">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-mini-fab mat-button color="accent" type="button" pTooltip="Reset" tooltipPosition="top" style="margin-left: 10px;margin-top: auto;
                        margin-bottom: auto;" (click)="resetWasteEnteryForm()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </form>
    <ag-grid-angular style="width: 100%;" class="ag-theme-alpine" [rowData]="rowDataHistory"
      [columnDefs]="columnDefsHistory" (gridReady)="onGridReady($event)" (cellClicked)="cellClickedHistory($event)"
      [gridOptions]="gridOptionsHistory" [pagination]="true" [paginationPageSize]="4"
      [loadingOverlayComponent]="loadingOverlayComponent">
    </ag-grid-angular>
  </mat-dialog-content>
</ng-template>

<ng-template #wastHistory>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between align-items-center">
      <h2>Waste History
      </h2>
      <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
  </div>
  <mat-dialog-content>
    <ag-grid-angular #ewastGrid style="width: 100%;" class="ag-theme-alpine" [rowData]="wastDataHistory"
      [columnDefs]="columnDefWastHistory" (gridReady)="onGridReadyWastHistory($event)" 
      [gridOptions]="gridOptionsWastHistory" (cellClicked)="cellClickedWasteGrid($event)" [pagination]="true" [paginationPageSize]="10"
      [loadingOverlayComponent]="loadingOverlayComponent" [suppressRowTransform]="true">
    </ag-grid-angular>
  </mat-dialog-content>
</ng-template>